












import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class FieldInput extends Vue {
  @Prop() value: string;
  @Prop() id: string;

  handleInput(newValue) {
    this.$emit('update', newValue);
  }

  setFocus() {
    const element: HTMLInputElement = this.$refs[this.id] as HTMLInputElement;
    element.focus();
  }

  handleEnter() {
    this.$emit('enter');
  }

  handleBlur() {
    this.$emit('blur');
  }

  mounted() {
    setTimeout(() => {
      this.setFocus();
    });
  }
}
